import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  AppBar, Toolbar, Typography, Box, IconButton,
  Backdrop, CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import MenuIcon from "@material-ui/icons/Menu";
import { logout } from "modules/login/redux/session.action";

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#3A4D54",
    boxShadow: "none",
    height: 56,
  },
  toolbar: {
    minHeight: 56,
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: 20,
    paddingRight: 16,
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: 20,
  },
  menuBtn: {
    color: "#fff",
    padding: 6,
    marginRight: -6,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.1)",
    },
  },
  portalBadge: {
    border: "2px solid #fff",
    borderRadius: 42,
    padding: "4px 12px",
    display: "inline-flex",
    alignItems: "center",
  },
  portalBadgeText: {
    fontSize: 14,
    fontWeight: 700,
    color: "#fff",
    lineHeight: "20px",
  },
  dividerVertical: {
    width: 1,
    height: 20,
    backgroundColor: "rgba(255,255,255,0.3)",
  },
  partnerName: {
    fontSize: 14,
    fontWeight: 700,
    color: "#fff",
    lineHeight: "20px",
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: 17,
  },
  userInfoSection: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  userTextBlock: {
    textAlign: "right",
  },
  userName: {
    fontSize: 13,
    fontWeight: 500,
    color: "#fff",
    lineHeight: "normal",
  },
  logoutBtn: {
    color: "rgba(255,255,255,0.7)",
    padding: 6,
    marginLeft: 4,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.1)",
    },
  },
  logoutBackdrop: {
    zIndex: theme.zIndex.drawer + 2,
    backgroundColor: "rgba(31, 41, 46, 0.75)",
  },
  logoutText: {
    marginTop: 14,
    fontSize: 14,
    fontWeight: 500,
    color: "#fff",
  },
}));

export default function Navbar({ drawerWidth, onToggleSidebar }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.session.user);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    // Hold the overlay briefly even when signout returns instantly, so the
    // transition reads as deliberate instead of a flicker.
    const minDisplay = new Promise((resolve) => setTimeout(resolve, 400));
    await Promise.all([dispatch(logout()), minDisplay]);
    history.push("/login");
  };

  return (
    <AppBar position="fixed" className={classes.appBar} elevation={0}>
      <Toolbar className={classes.toolbar}>
        <Box className={classes.leftSection}>
          <IconButton className={classes.menuBtn} size="small" onClick={onToggleSidebar} aria-label="Toggle menu">
            <MenuIcon />
          </IconButton>
          <Box className={classes.portalBadge}>
            <Typography className={classes.portalBadgeText}>Partnership Portal</Typography>
          </Box>
          <Box className={classes.dividerVertical} />
          <Typography className={classes.partnerName}>
            {user?.partner_name || ""}
          </Typography>
        </Box>
        <Box className={classes.rightSection}>
          <Box className={classes.userInfoSection}>
            <Box className={classes.userTextBlock}>
              <Typography className={classes.userName}>
                {user?.name || user?.email || "Partner"}
              </Typography>
            </Box>
          </Box>
          <IconButton className={classes.logoutBtn} onClick={handleLogout} size="small" disabled={isLoggingOut}>
            <ExitToAppIcon fontSize="small" />
          </IconButton>
        </Box>
      </Toolbar>
      <Backdrop open={isLoggingOut} className={classes.logoutBackdrop}>
        <Box textAlign="center">
          <CircularProgress size={32} style={{ color: "#fff" }} />
          <Typography className={classes.logoutText}>Signing out…</Typography>
        </Box>
      </Backdrop>
    </AppBar>
  );
}
